import React from 'react';
import { User } from '@/types/model';

const StatusBadge: React.FC<{ status: User['status'] }> = ({ status }) => {
  const statusConfig = {
    ACTIVE: { bg: 'bg-green-500', label: 'Activo' },
    INACTIVE: { bg: 'bg-red-500', label: 'Inactivo' },
    SUSPENDED: { bg: 'bg-gray-600', label: 'Suspendido' }
  };

  const config = statusConfig[status];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs ${config.bg}  text-white font-bold justify-center`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
